import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import textContent from "./contents.json";
import { nextBirthdayAsStr } from './birthday-calc';
import BirthdayCalendarButton from './calendar/BirthdayCalendarButton';
import CatGameButton from './game/CatGameButton';

export default function TopBar(props: any) {

    const styles = {
        maxWidth: {
            width: "100%"
        },
        strikethru: {
            textDecoration: "line-through"
        }
    };

    return (
        <Box>
            <AppBar style={styles.maxWidth}>
                <Toolbar>
                    {/* Align text with center of screen */}
                    <Typography variant="h5" component="div">
                        { textContent["topBar"]["textBeginning"] }
                    </Typography>
                    {textContent["topBar"]["textStruckThrough"] ? (<>
                    &nbsp;
                    <Typography variant="h5" component="div" style={styles.strikethru}>
                        { textContent["topBar"]["textStruckThrough"] }
                    </Typography>
                    &nbsp;</>) : <>&nbsp;</>}
                    <Typography variant="h5" component="div">
                        { textContent["topBar"]["textEnd"]}
                    </Typography>
                    &nbsp;
                    <Box sx={{ ml: 1 }}>
                        <BirthdayCalendarButton label={`Next Birthday Is ${nextBirthdayAsStr()}`}/>
                    </Box>
                    <Box sx={{ ml: 1 }}>
                        <CatGameButton/>
                    </Box>
                </Toolbar>
            </AppBar>
        </Box>
    );
}